(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('MaterialSearch', MaterialSearch);

    MaterialSearch.$inject = ['$resource'];

    function MaterialSearch($resource) {
        var resourceUrl =  'api/_search/materials/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
